import { render } from "./IconItemCategoryBeauty.vue?vue&type=template&id=7101233a"
import script from "./IconItemCategoryBeauty.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryBeauty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__